import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import classNames from 'classnames';
import CardWidgetErrorsContainer from '../CardWidgetErrorsContainer';
import './CardWidgetInputErrorHOC.scss';

function CardWidgetInputErrorHOC(WrappedComponent) {
  class CardWidgetErrorHoc extends Component {
    render() {
      let {errorMessage, ...rest} = this.props;
      let className = classNames({'hrb-card-widget-input-with-error': errorMessage});

      return(
        <div className={className}>
          <WrappedComponent {...rest} />
          <CardWidgetErrorsContainer errorMessage={errorMessage}/>
        </div>
      );
    }
  }

  CardWidgetErrorHoc.propTypes = {
    errorMessage: PropTypes.string
  };

  return CardWidgetErrorHoc;
}


export default CardWidgetInputErrorHOC;